import React, {useState} from 'react';
import Button from '@components/Button'
import {
    FiltersContainer,
    FiltersControls,
    FiltersButton,
    FiltersTitle
} from './index.style'
import Filter from './filter'
import IconMinus from '@svgs/IconMinus';
import IconPlus from '@svgs/IconPlus';
import PropTypes from 'prop-types';

const Filters = ({changeFilter, handleActivateAll, currentFilter}) => {
    const [active, setActive] = useState();
    const filters = [
        {
            title: 'All',
            slug: 'all',
            filter: ''
        },
        {
            title: 'Paid Performance',
            slug: 'paid-performance',
            filter: 'Service: Paid Performance'
        },
        {
            title: 'Organic Performance',
            slug: 'organic-performance',
            filter: 'Service: Organic Performance'
        },
        {
            title: 'Digital Media Network',
            slug: 'digital-media-network',
            filter: 'Service: Digital Media Network'
        },
        {
            title: 'Fan Engagement',
            slug: 'fan-engagement',
            filter: 'Service: Fan Engagement'
        },
        {
            title: 'Technology & Experience',
            slug: 'technology-and-experience',
            filter: 'Service: Technology & Experience'
        },
        {
            title: 'Social & Influencer',
            slug: 'social-influencer',
            filter: 'Service: Social & Influencer'
        },
        {
            title: 'Insights & Consultancy',
            slug: 'insights-consultancy',
            filter: 'Service: Insights & Consultancy'
        },
    ]

    const changeFilters = (filter) => {
        setActive(false);
        changeFilter(filter);
    }
    return (
        <FiltersContainer>
            <FiltersButton onClick={() => setActive(!active)}>
                <FiltersTitle>Business Units</FiltersTitle>
                {active ?
                <IconMinus />
                :
                <IconPlus />
                }
            </FiltersButton>
            <FiltersControls className="scroll-container" active={active}>
                {filters.map((item, index) => (
                    <Filter item={item} setCurrentFilter={changeFilters} currentFilter={currentFilter} key={index} />
                ))}
            </FiltersControls>
        </FiltersContainer>
    );
};

Filters.propTypes = {
    
};

export default Filters;